import { Cohort, CohortTrainingStatus, TrainingType } from "src/types/Cohort";

export default function isCohortGuard(obj: unknown): obj is Cohort {
  const cohort = obj as Cohort;

  const checks = {
    exists: !!cohort,
    isObject: typeof cohort === "object",
    hasUid: typeof cohort?.uid === "string",
    hasName: typeof cohort?.name === "string",
    hasOrgId: typeof cohort?.organizationId === "string",
    hasStartDate: typeof cohort?.startDate === "string",
    validTrainingType: cohort?.trainingType
      ? Object.values(TrainingType).includes(cohort.trainingType)
      : false,
    validStatus: cohort?.status
      ? Object.values(CohortTrainingStatus).includes(cohort.status)
      : false,
  };

  const isValid =
    checks.exists &&
    checks.isObject &&
    checks.hasUid &&
    checks.hasName &&
    checks.hasOrgId &&
    checks.hasStartDate &&
    checks.validTrainingType &&
    checks.validStatus;

  return isValid;
}
